import axios from 'axios';

// const cancelToken = axios.CancelToken;
// axios.interceptors.request.use(
//   (config) => {
//     console.log(config);
//     if (config.url === 'https://uat.yaotongyun.com/system/newDrug/get') {
//       // return 1111111
//       config.cancelToken = new cancelToken((c) => {
//         c(123);
//       });
//     }
//     return config;
//   },
//   err => Promise.resolve(err),
// );


// 响应拦截器
axios.interceptors.response.use(
  response => response,
  (error) => {
    console.log(error.message);
    return { data: Promise.resolve(error.message) }; // 返回接口返回的错误信息（这里返回空对象是为了避免控制台报错）
  },
);
class requstHelper {
  static fetch = (url, data, option = {}) => {
    // console.log(`${process.env.API_HOST}${url}`);
    // console.log('请求', data);
    const data1 = {
      url: `${process.env.API_HOST}${url}`, // 请求地址
      headers: option.header ? option.header : {},
      method: option.method ? option.method : 'POST',
      dataType: option.dataType ? option.dataType : 'json',
    };
    if (option.method === 'GET') { // 如果是get请求  传入参数的字段一定要是params  如果是post请求则是叫data
      data1.params = data;
    } else {
      data1.data = data;
    }
    // console.log(data1)
    return new Promise((resovle, reject) => {
      axios(data1).then((rep) => {
        // console.log('请求响应', rep);
        const repData = rep.data;
        // 发生错误的场合
        if (repData.code === 0) {
          const message = repData.message || repData.msg;
          reject(message);
        } else {
          resovle(repData);
        }
      }).catch((err) => {
        reject(err);
      });
    });
  }
}

export default requstHelper;



// WEBPACK FOOTER //
// ./src/common/service/requstHelper.js